import React from 'react';
import { Calculator, Sliders, Wrench } from 'lucide-react';

const CalculationMethodSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-gray-500 dark:text-gray-400" />
        Дополнительные коэффициенты и метод расчета
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        {/* Коэффициент запаса */}
        <div>
          <label htmlFor="maintenanceFactor" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Wrench className="w-4 h-4 mr-2 text-gray-500" />
            Коэффициент запаса (загрязнения)
          </label>
          <select
            id="maintenanceFactor"
            name="maintenanceFactor"
            value={formData.maintenanceFactor}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.maintenanceFactor ? 'input-error' : ''}`}
          >
            <option value="1.0">1.0 - Идеально чистое помещение</option>
            <option value="0.9">0.9 - Очень чистое помещение</option>
            <option value="0.8">0.8 - Чистое помещение (жилое, офис)</option>
            <option value="0.7">0.7 - Средне загрязненное (общественное)</option>
            <option value="0.6">0.6 - Загрязненное (промышленное)</option>
            <option value="0.5">0.5 - Сильно загрязненное</option>
          </select>
          {errors.maintenanceFactor && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.maintenanceFactor}
            </p>
          )}
        </div>

        {/* Коэффициент использования */}
        <div>
          <label htmlFor="utilizationFactor" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Sliders className="w-4 h-4 mr-2 text-gray-500" />
            Коэффициент использования светового потока
          </label>
          <input
            type="text"
            id="utilizationFactor"
            name="utilizationFactor"
            value={formData.utilizationFactor}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.utilizationFactor ? 'input-error' : ''}`}
            placeholder="Введите коэффициент (0.4-0.7)"
          />
          {errors.utilizationFactor && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.utilizationFactor}
            </p>
          )}
        </div>
      </div>

      {/* Метод расчета */}
      <div className="mb-4">
        <div className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Метод расчета освещения
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          <label className="flex items-center p-3 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 cursor-pointer">
            <input
              type="radio"
              name="calculationMethod"
              value="lumen"
              checked={formData.calculationMethod === 'lumen'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            <div>
              <div className="text-sm font-medium">Метод светового потока</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Стандартный метод</div>
            </div>
          </label>
          
          <label className="flex items-center p-3 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 cursor-pointer">
            <input
              type="radio"
              name="calculationMethod"
              value="point"
              checked={formData.calculationMethod === 'point'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            <div>
              <div className="text-sm font-medium">Точечный метод</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">Для сложной геометрии</div>
            </div>
          </label>
          
          <label className="flex items-center p-3 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 cursor-pointer">
            <input
              type="radio"
              name="calculationMethod"
              value="automatic"
              checked={formData.calculationMethod === 'automatic'}
              onChange={handleInputChange}
              className="form-radio mr-2"
            />
            <div>
              <div className="text-sm font-medium">Автоматический расчет</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">С корректировкой коэффициентов</div>
            </div>
          </label>
        </div>
      </div>

      {/* Информация о методах расчета */}
      <div className="bg-gray-100 dark:bg-gray-700 p-3 rounded-lg border border-gray-200 dark:border-gray-600">
        <div className="flex items-start">
          <Calculator className="w-5 h-5 text-gray-500 dark:text-gray-400 mr-3 mt-0.5" />
          <div>
            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              О методах расчета освещения
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              <strong>Метод светового потока</strong> (метод коэффициента использования) - основной метод для равномерного освещения, рекомендованный в России.
              <br />
              <strong>Точечный метод</strong> - для расчета освещенности в конкретной точке, учитывает кривые силы света светильников.
              <br />
              <strong>Автоматический</strong> - калькулятор оценит оптимальные коэффициенты на основе параметров помещения.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalculationMethodSection;